import React from 'react';
import { useNavigate } from 'react-router-dom';

const PolymarketView = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-800">Polymarket Positions</h2>
        <button 
          onClick={() => navigate('/dashboard')} 
          className="text-blue-600 hover:text-blue-800 text-sm"
        >
          ← Back to Dashboard
        </button>
      </div>

      <div className="text-center py-8">
        <p className="text-gray-600">Polymarket integration is ready.</p>
        <p className="text-gray-500 mt-2">This will display your prediction market positions.</p>
      </div>

      <button 
        onClick={() => navigate('/dashboard')} 
        className="mt-4 text-blue-600 hover:text-blue-800"
      >
        ← Back to Dashboard
      </button>
    </div>
  );
};

export default PolymarketView;